import { lazy, Suspense } from 'react';

import { useGetAmendmentByIdQueryV2 } from '@xemplo/amendment-query';
import { PAYRUN_COMPONENTS } from '@xemplo/gp-constants';
import { CenteredLoaderDots } from '@xemplo/loader';
import { RoleRenderer } from '@xemplo/role-renderer';
import { AuthorisationModule } from '@xemplo/role-types';

import { getEditButtonType } from './footer/edit-button/edit-button.helper';

const EditAmendmentContent = lazy(() =>
  import('@xemplo/edit-amendment-modal').then((m) => ({
    default: m.EditAmendmentContent,
  })),
);
const EditTerminationContent = lazy(() =>
  import('@xemplo/edit-termination-modal').then((m) => ({
    default: m.EditTerminationContent,
  })),
);
const EditPayInstructionContent = lazy(() =>
  import('@xemplo/edit-pay-instruction-modal').then((m) => ({
    default: m.EditPayInstructionContent,
  })),
);

const LazyEditContentMap = {
  amendment: EditAmendmentContent,
  termination: EditTerminationContent,
  payInstruction: EditPayInstructionContent,
};

export interface EditContentFactoryProps {
  amendmentId: string;
  onClose: () => void;
  onSubmitSuccess?: () => void;
}

export function EditContentFactory({ amendmentId, onClose }: EditContentFactoryProps) {
  const { data: amendment } = useGetAmendmentByIdQueryV2({ id: amendmentId });
  if (!amendment) return null;

  const type = getEditButtonType(amendment);
  if (!type) return null;

  const EditContent = LazyEditContentMap[type];

  return (
    <RoleRenderer
      module={AuthorisationModule.payrun}
      component={PAYRUN_COMPONENTS.AMENDMENT_EDIT}
    >
      <Suspense fallback={<CenteredLoaderDots />}>
        <EditContent
          amendmentId={amendmentId}
          onClose={onClose}
          onSubmitSuccess={onClose}
        />
      </Suspense>
    </RoleRenderer>
  );
}
